var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"output"}},[_c('Menu',{on:{"screenshot":_vm.snapScreenshot}}),_c('section',{ref:"groups",staticClass:"groups"},_vm._l((_vm.groups),function(group){return _c('Group',{key:group.id,attrs:{"group":group}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }